import { CommonDialogProps, DialogConfig } from '../common/types'
import { SelectNetworkDialogContentContainer } from './SelectNetworkDialogContentContainer'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export type SelectNetworkDialogProps = CommonDialogProps & {
  asDrawer?: boolean
}

function SelectNetworkDialog({ open, setOpen, asDrawer }: SelectNetworkDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent contentVerticalPosition={asDrawer ? 'bottom' : 'center'}>
        <SelectNetworkDialogContentContainer closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const selectNetworkDialogConfig: DialogConfig<SelectNetworkDialogProps> = {
  options: {
    closeOnAccountChange: false,
  },
  element: SelectNetworkDialog,
  name: 'SelectNetworkDialog',
}
